import React from "react";
import "./Clients.css";
import { CLIENTS } from '../../data/siteData';

export default function Clients() {
  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <section className="clients-page" id="clients">
      {/* Background Neon Atmospheric Glows */}
      <div className="dark-glow-1"></div>
      <div className="dark-glow-2"></div>
      
      <div className="clients-sec">
        {/* Header Section */}
        <div className="exp-header">
          <p className="exp-eyebrow">
            <span className="eyebrow-dot"></span>
            Our Trusted Partners
          </p>
         
          <p className="exp-desc">
            We partner with enterprises, innovative startups, and global organizations to build cutting-edge digital experiences, seamless automation, and scalable cloud solutions.
          </p>
        </div>

        {/* Clients Marquee */}
        <div className="clients-marquee">
          {/* Track 1: Right to Left */}
          <div className="clients-track1">
            {loop.map((c, i) => (
              <a
                key={`track1-${i}`}
                href={c.url}
                target="_blank"
                rel="noopener noreferrer"
                className="client-logo"
              >
                {c.image && c.image !== c.name ? (
                  <div className="client-image-wrapper">
                    <img
                      src={c.image}
                      alt={c.name}
                      className="client-image"
                    />
                  </div>
                ) : (
                  <span className="client-mark">
                    {c.initial}
                  </span>
                )}
                <span className="client-name">{c.name}</span>
              </a>
            ))}
          </div>

          {/* Track 2: Left to Right
          <div className="clients-track2">
            {loop.map((c, i) => (
              <a
                key={`track2-${i}`}
                href={c.url}
                target="_blank"
                rel="noopener noreferrer"
                className="client-logo"
              >
                {c.image && c.image !== c.name ? (
                  <div className="client-image-wrapper">
                    <img
                      src={c.image}
                      alt={c.name}
                      className="client-image"
                    />
                  </div>
                ) : (
                  <span className="client-mark">
                    {c.initial}
                  </span>
                )}
                <span className="client-name">{c.name}</span>
              </a>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
}